module.exports = __webpack_public_path__ + "static/media/sample-csv.def1cd36.csv";